import { Box, Button, Dialog, DialogContent, FormControl, FormHelperText, IconButton, InputLabel, MenuItem, Select, TextField, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useResumeBuilderStore } from '../../../store/resumebuilder.store'
import * as Yup from 'yup'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import { useNavigate } from 'react-router-dom'
import { Icons } from '../../../utils/utilities'
import CustomSelectField from '../../common/CustomSelectField'

const AddResumeTemplateDialog = ( { state, setAddDialogState } ) => {

    const [resumeForms, setResumeForms] = useState( [] )
    const [loading, setLoading] = useState( true )
    const ResumeBuilderStore = useResumeBuilderStore()

    const navigate = useNavigate()
    const { palette, border } = useTheme()

    const initialValues = {
        name: '',
        description: '',
        formId: ''
    }

    const validationSchema = Yup.object().shape( {
        name: Yup.string().required( "Template name is required!" ),
        description: Yup.string().required( "Template description is required!" ),
        formId: Yup.string().required( "Please select the form" )
    } )


    const createTemplate = async ( values, { resetForm } ) => {
        await ResumeBuilderStore.createTemplate( values )
        resetForm()
        setAddDialogState( false )
        navigate( `/admin/resume-templates/${ResumeBuilderStore.getTemplate.id}` )
    }

    useEffect( () => {
        const getData = async () => {
            await ResumeBuilderStore.fetchForms()
            setResumeForms( ResumeBuilderStore.getForms )
            setLoading( false )
        }
        getData()
    }, [ResumeBuilderStore] )

    return (
        <Dialog open={state}>
            <Box display="flex" position="sticky" top="0" zIndex="10" bgcolor={palette.background.paper} alignItems="center" justifyContent="space-between" padding="20px" borderBottom={border[1]}>
                <Box>
                    <Typography variant="h1" fontWeight="600" component="h1" fontSize="16px">Add new resume template</Typography>
                    <Typography variant="subtitle2" fontSize="12px" color='textSecondary'>Fill in details to create a new resume template.</Typography>
                </Box>
                <IconButton onClick={() => setAddDialogState( false )} >
                    {Icons.default.CloseIcon}
                </IconButton>
            </Box>
            <DialogContent >
                <Formik onSubmit={createTemplate} initialValues={initialValues} validationSchema={validationSchema}>
                    {( { values, setFieldValue } ) => {
                        return ( <Form>
                            <FormControl fullWidth margin='normal'>
                                <Typography component="label" display="block" htmlFor="template-name" gutterBottom variant="subtitle2" color={palette.form.labelColor}>Template name * </Typography>
                                <Field placeholder="Eg: Template for software developer" size="small" sx={{ fontSize: "14px" }} as={TextField} name='setting_label' id="template-name" type='text' />
                                <FormHelperText><ErrorMessage name='name' /></FormHelperText>
                            </FormControl>
                            <FormControl fullWidth margin='normal'>
                                <Typography component="label" display="block" htmlFor="template-description" gutterBottom variant="subtitle2" color={palette.form.labelColor}>Template description * </Typography>
                                <Field placeholder="Eg: Custom mode resume template for the role of software developer." size="small" sx={{ fontSize: "14px" }} as={TextField} name='setting_label' id="template-description" type='text' />
                                <FormHelperText><ErrorMessage name='description' /></FormHelperText>
                            </FormControl>
                            <FormControl fullWidth margin='normal'>
                                <Typography component="label" display="block" htmlFor="template-form" gutterBottom variant="subtitle2" color={palette.form.labelColor}>Select resume form to consider for this template * </Typography>
                                <CustomSelectField
                                    data={resumeForms}
                                    size="small"
                                    value={values.formId}
                                    onChange={e => setFieldValue( 'formId', e.target.value )}
                                    placeholder="Select Resume Form"
                                    id='template-form'
                                    itemValueKey="id"
                                    renderOptionText={item => item.name}
                                />
                                <FormHelperText><ErrorMessage name='formId' /></FormHelperText>
                            </FormControl>
                            <Box marginTop="20px" display="flex" gap="10px" alignItems="center" flexWrap="wrap">
                                <Button disableElevation variant="contained" type="submit" sx={{ textTransform: "capitalize" }}>Create Template</Button>
                                <Button color="error" onClick={() => setAddDialogState( false )} variant="outlined" sx={{ textTransform: "capitalize" }}>Cancel</Button>
                            </Box>
                        </Form> )
                    }}
                </Formik>
            </DialogContent>
        </Dialog>
    )
}

export default AddResumeTemplateDialog
